export class MainScene extends Phaser.Scene {
    private easel: Phaser.GameObjects.Image;
    private easelControls: Phaser.GameObjects.Image;
    private images = ["chestBlue", "chestGreen", "chestRed", "chestYellow", "clear"];
    private currentImage: string = "clear";
    private imageWidth = 75;
    private imageHeight = 75;
    private cursors;
    private currentWidthText: Phaser.GameObjects.Text;
    private currentHeightText: Phaser.GameObjects.Text;
    private paste: Phaser.GameObjects.Image;
    private currentPaste: Phaser.GameObjects.Image;
    private clearButton: Phaser.GameObjects.Image;

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("background", require("/src/assets/games/coinRunner/background.png"));
        this.load.image("control-background", require("/src/assets/phaser-assets/textures/wood_by_EricHart3d.png"));
        this.load.image("chestBlue", require("/src/assets/online-assets/sprites/ChestBlue.png"));
        this.load.image("chestGreen", require("/src/assets/online-assets/sprites/ChestGreen.png"));
        this.load.image("chestRed", require("/src/assets/online-assets/sprites/ChestRed.png"));
        this.load.image("chestYellow", require("/src/assets/online-assets/sprites/ChestYellow.png"));
        this.load.image("clear", require("/src/assets/online-assets/sprites/clear.png"));
    }
    create(): void {
        this.createEasel();
        this.createKeyboards();
        this.createText();
        this.generateEvents();
    }

    createKeyboards() {
        this.cursors = this.input.keyboard.addKeys
            ({
                makeTaller: Phaser.Input.Keyboard.KeyCodes.UP,
                makeShorter: Phaser.Input.Keyboard.KeyCodes.DOWN,
                makeSlimmer: Phaser.Input.Keyboard.KeyCodes.LEFT,
                makeWider: Phaser.Input.Keyboard.KeyCodes.RIGHT,
            });
    }

    createEasel() {
        var easelArea = { width: 600, height: 600 };
        var controlArea = { width: 200, height: 600 };

        // Generate Easel
        this.easel = this.add.image(0, 0, "background");
        this.easel.setOrigin(0, 0);
        this.easel.setDisplaySize(easelArea.width, easelArea.height);
        this.easel.setInteractive();
        this.easel.depth = -1;
        this.easel.on('pointerdown', (pointer) => {
            this.pasteImage(pointer);
        }, this);

        // Generate Control area
        this.easelControls = this.add.image(easelArea.width, 0, "control-background");
        this.easelControls.setOrigin(0, 0);
        this.easelControls.setDisplaySize(controlArea.width, controlArea.height);
        this.easelControls.depth = 1;

        //Generate Images
        var buttonSize = { height: 75, width: 75 };
        var yCoord = 200;
        for (const image of this.images) {
            var button = this.add.image(this.easelControls.x + 20, yCoord, image);
            button.setOrigin(0);
            button.setDepth(1);
            button.setInteractive();
            button.setDisplaySize(buttonSize.width, buttonSize.height);
            button.on("pointerdown", () => {
                this.currentImage = image;
                this.currentPaste.setTexture(this.currentImage);
            });
            yCoord += 75;
        }

        this.currentPaste = this.add.image(this.easelControls.x + 110, this.easelControls.y + 10, "clear");
        this.currentPaste.setOrigin(0);
        this.currentPaste.setDepth(1);
        this.currentPaste.setDisplaySize(75, 75);
    }

    pasteImage(pointer) {
        if (this.currentImage !== "clear") {
            this.paste = this.add.image(pointer.x, pointer.y, this.currentImage);
            this.paste.setInteractive();
            this.paste.setDisplaySize(this.imageWidth, this.imageHeight);
            this.input.setDraggable(this.paste);
        }
    }

    generateEvents() {
        // Wire up events
        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image) => {
            gameObject.x = pointer.downX;
            gameObject.y = pointer.downY;
            gameObject.setAngle();
            this.children.bringToTop(gameObject);
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image, dragX: number, dragY: number) => {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image) => {
            this.children.moveDown(gameObject);
        });
    }

    createText() {
        this.createTextInstances(this.easelControls.x + 10, this.easelControls.y + 30, "Image:");
        this.createTextInstances(this.easelControls.x + 10, this.easelControls.y + 90, "Width: ");
        this.createTextInstances(this.easelControls.x + 10, this.easelControls.y + 150, "Height: ");
        this.currentWidthText = this.add.text(this.easelControls.x + 120, this.easelControls.y + 90, "",
            {
                fontSize: '24px',
                fill: '#ffffff'
            });
        this.currentWidthText.setOrigin(0);
        this.currentWidthText.setDepth(1);
        this.currentHeightText = this.add.text(this.easelControls.x + 120, this.easelControls.y + 150, "",
            {
                fontSize: '24px',
                fill: '#ffffff'
            });
        this.currentHeightText.setOrigin(0);
        this.currentHeightText.setDepth(1);
    }

    createTextInstances(x: number, y: number, textString: string) {
        var text = this.add.text(x, y, textString,
            {
                fontSize: '24px',
                fill: '#ffffff'
            });
        text.setOrigin(0);
        text.setDepth(1);
    }

    update(): void {
        this.updateSize();
        this.updateText();
    }
    updateSize() {
        if (this.cursors.makeTaller.isDown) {
            this.imageHeight++;
        }
        if (this.cursors.makeShorter.isDown) {
            this.imageHeight--;
        }
        if (this.cursors.makeSlimmer.isDown) {
            this.imageWidth--;
        }
        if (this.cursors.makeWider.isDown) {
            this.imageWidth++;
        }
    }
    updateText() {
        this.currentWidthText.setText("" + this.imageWidth);
        this.currentHeightText.setText("" + this.imageHeight);
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserImagePasteDemo/scenes/MainScene.ts